<template>
    <div class="search-home">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="search-home__title">
                        Ищут дом
                    </h5>
                </div>
            </div>
            <div class="search-home__content">
                <div class="row" v-if="loaded">
                    <div class="col-md-12" v-if="list.length">
                        <swiper ref="swiper" class="swiper" :options="swiperOptions">
                            <swiper-slide class="search-home__slide" v-for="(slide, idx) in list" :key="idx">
                                <div class="search-home__item d-flex">
                                    <div class="search-home__item-header">
                                        <a :href="`/pets/${slide.id}`"
                                           class="search-home__item-image"
                                           :style="{backgroundImage: slide.avatar ?
                                           `url(/storage/${slide.avatar.path.replace('original', 'preview_l')})` : 'none'}"></a>
                                        <div class="search-home__item-label"></div>
                                    </div>
                                    <div class="search-home__item-body d-flex">
                                        <div class="search-home__item-title d-flex" v-if="slide.name">
                                            <a :href="`/pets/${slide.id}`">
                                                <h4 v-text="slide.name"></h4>
                                            </a>
                                            <span class="search-home__item-city d-flex" v-if="slide.city"><span class="lnr lnr-map-marker"></span> {{ slide.city.name }}</span>
                                        </div>
                                        <div class="search-home__item-content" v-if="slide.ad_title" v-text="slide.ad_title"></div>
                                        <div class="search-home__item-actions d-flex">
                                            <a href="#" class="btn btn--rounded" v-if="(slide && user) ? +slide.user_id !== +user.id : false" data-toggle="modal" data-target="#ownerShipModal" @click="openModal(slide)">Стать хозяином</a>
                                            <a href="/auth/login" class="btn btn--rounded" v-if="(!user)">Стать хозяином</a>
                                            <a :href="`/pets/${slide.id}`" class="btn btn--rounded btn-light">Подробнее</a>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>

                        <div class="d-flex justify-content-end mt-5 search-home__nav" v-if="list.length">
                            <div class="slider-navigations d-flex">
                                <div id="home-search-prev" class="swiper-button-prev" slot="button-prev"></div>
                                <div id="home-search-next" class="swiper-button-next" slot="button-next"></div>
                            </div>
                            <a href="/catalog/seek_home" class="btn">Смотреть все</a>
                        </div>


                        <!-- Modal -->
                        <div class="modal fade" id="ownerShipModal" v-if="modalPet" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLongTitle">Стать хозяином для {{ modalPet.name }}</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body" v-if="!ownerShiping">
                                        <form action="#">
                                            <div class="mb-3">
                                                <input type="text" class="form-control" v-model="$v.ownerShipingForm.phone.$model" v-mask="'+375 (##) ###-##-##'" placeholder="+375 (29) 111-11-11">
                                                <div class="text-danger" v-if="$v.ownerShipingForm.phone.$error">Поле имеет неверное значение</div>
                                            </div>
                                            <div>
                                                <textarea class="form-control" type="text" v-model="$v.ownerShipingForm.comment.$model" rows="3" placeholder="Комментарий"></textarea>
                                                <div class="text-danger" v-if="$v.ownerShipingForm.comment.$error">Оставьте комментарий</div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-body" v-else>
                                        Ваша заявка принята и отправлена на рассмотрение.
                                    </div>
                                    <div class="modal-footer" v-if="!ownerShiping">
                                        <button type="button" class="btn btn-primary"
                                                :style="{background: ownerShiping ? '#77de51' : '#0674ec'}"
                                                @click.prevent="applyOwnership(+modalPet.id)">Подтвердить
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" v-else>
                        <div class="empty__wrapper d-flex">
                            Список пуст.
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-md-12">
                        <div class="empty__wrapper d-flex">
                            <div class="LoaderBalls">
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {mask} from 'vue-the-mask'
import {helpers, required, numeric, decimal, email, minValue} from 'vuelidate/lib/validators';

const phoneValidator = helpers.regex('phone', /^\+375\s\((29|44|33|25)\)\s[1-9]{1}\d{2}-\d{2}-\d{2}$/g);

export default {
    name: "SearchHome",
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {mask},
    data() {
        return {
            list: [],
            loaded: false,
            modalPet: null,
            swiperOptions: {
                slidesPerView: 3,
                spaceBetween: 32,
                navigation: {
                    nextEl: '#home-search-next',
                    prevEl: '#home-search-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    },
                },
            },

            ownerShiping: false,
            ownerShipingForm: {
                pet_id: null,
                comment: null,
                phone: null,
            }
        }
    },

    computed: {
        swiper() {
            return this.$refs.swiper.$swiper
        },

        user() {
            return this.$store.getters.getUserData;
        }

    },

    watch: {
        list() {
            setTimeout(() => {
                this.loaded = true
            }, 1000)
        }
    },


    mounted() {
        this.getPets()
    },

    validations: {
        ownerShipingForm: {
            pet_id: {required},
            comment: {required},
            phone: {required, phoneValidator}
        }
    },

    methods: {
        openModal(pet) {
            if (!pet) return

            this.modalPet = pet
        },

        applyOwnership(idx) {
            if (!this.user) {
                return window.location.href = `${window.location.origin}/auth/login`
            }

            let ownerModalClose = document.querySelector('#ownerShipModal .close'),
                params = {
                    comment: this.ownerShipingForm.comment,
                    pet_id: idx,
                    details: {phone: this.ownerShipingForm.phone.replace(/([(]|[)])|(-)|(\s)/g, '')}
                };

            axios.post('/api/interactions/ownership/apply', params)
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        this.ownerShiping = true;

                        setTimeout(() => {
                            ownerModalClose.click()
                            this.ownerShiping = false;
                        }, 2000)
                    }
                })
                .catch((error) => {
                    alert('Произошла ошибка! Попробуйте обновить страницу и попробовать еще раз');
                })
        },


        getPets() {
            let url = `/catalog/seek_home`;

            axios.get(url, {
                params: {
                    per_page: 30
                }
            })
                .then(response => {
                    response = response.data
                    if (response.extended_data.success) {
                        this.list = response.data.filter(item => {
                            return item.type !== 'PET_TYPE_MYSELF'
                        })
                    }
                })
                .catch(error => {
                    error = error.response.data
                    console.log(error)
                })

        }

    }


}
</script>

<style lang="scss" scoped>

.search-home {

    background-image: url('/assets/images/get-home.svg');
    background-color: #eff1f3;
    background-size: 91%;
    background-repeat: no-repeat;
    padding-top: 95px;
    padding-bottom: 55px;
    background-position-y: 30px;

    position: relative;

    &::before {
        position: absolute;
        left: 50%;
        bottom: 20px;
        top: 20px;
        width: 100%;
        max-width: 1000px;

        transform: translateX(-50%);
        display: block;
        content: '';

        background: transparent url("/assets/images/icons/home-background.svg") no-repeat center bottom/contain;
    }


    &__title {
        font-size: 36px;
        font-weight: bold;
        margin-bottom: 20px;
        color: #333333;

    }


    .empty__wrapper {
        min-height: 200px;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 28px;
        line-height: 30px;
    }

    &__content {

        .swiper-container {
            padding: 20px 0;
        }

        .swiper-slide {
            height: auto;
        }

        .swiper-button-next, .swiper-button-prev {
            position: static;
            background: #EAF1FC;
            border-radius: 20px;
            width: 56px;
            height: 40px;
            outline: none;
            margin: 0 10px;
        }

        .swiper-button-prev:after,
        .swiper-button-next:after {
            color: transparent;
        }

        .swiper-button-prev:after {
            background: url(/assets/images/slide-arw-right.svg) no-repeat;
            background-size: contain;
            background-position: 50% 50%;
            transform: rotate(180deg);
        }

        .swiper-button-next:after {
            background: url(/assets/images/slide-arw-right.svg) no-repeat;
            background-size: contain;
            background-position: 50% 50%;
        }

        .slider-navigations {
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
        }

    }


    &__item {
        flex-direction: column;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        overflow: hidden;
        font-size: 12px;
        line-height: 20px;
        height: 100%;

        &-header {
            position: relative;
        }

        &-image {
            display: block;
            height: 265px;
            border-radius: 5px;
            background: transparent no-repeat center/cover;

        }

        &-label {
            position: absolute;
            right: 16px;
            top: 16px;
            width: 24px;
            height: 24px;
            background: #91DA66;
            border-radius: 50%;
            overflow: hidden;


            &::before {
                display: block;
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                background: #fff;

                -webkit-mask: url('/assets/images/icons/home.svg') no-repeat center / 15px;
                mask: url('/assets/images/icons/home.svg') no-repeat center / 15px;

            }

        }

        &-body {
            flex-direction: column;
            flex-grow: 1;
            padding: 15px;
        }

        &-title {
            justify-content: space-between;
            margin-bottom: 10px;

            a {
                font-weight: bold;
                font-size: 18px;
                line-height: 26px;
                color: #333;
                transition: opacity .2s ease;

                &:hover {
                    opacity: .8;
                }

            }

            h4 {
                margin-bottom: 0;
            }

        }

        &-city {
            font-size: 12px;
            line-height: 20px;
            color: #929292;
            align-items: center;

            span {
                margin-right: 3px;
            }
        }

        &-content {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-bottom: 25px;
            flex-grow: 1;
        }

        &-actions {
            justify-content: center;
            margin: 0 -3px;

            .btn {
                margin: 0 3px;
            }
        }
    }


}

.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6, .05, .15, .95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}


@media screen and (max-width: 1200px) {

    #main-page .search-home__item-actions .btn {
        padding: 10px;

    }

}

@media screen and (max-width: 992px) {
    #main-page .search-home__item-actions .btn {
        flex-grow: 1;
        max-width: 170px;
    }
}

@media screen and (max-width: 768px) {

    .search-home {

        .empty__wrapper {
            font-size: 20px;
            line-height: 22px;
        }

        &__title {
            font-size: 26px;
            line-height: 30px;
            text-align: center;
            width: 100%;
        }


    }

}


@media screen and (max-width: 500px) {

    #main-page .search-home__item-actions .btn {
        flex-grow: 1;

    }

    .search-home {
        background-image: none;

        &::before {
            top: 20px;
            bottom: 0;
            background-position: center top;
        }

        &__content {
            .slider-navigations {
                position: static;
                left: unset;
                transform: none;
                margin-bottom: 15px;
            }

            .swiper-button-next, .swiper-button-prev {
                background: #fff;
            }

        }

        &__nav {
            flex-direction: column;
            align-items: center;
            justify-content: center !important;

        }
    }

}


</style>
